import Icon from 'components/Icon';
import React, { useContext } from 'react';
import { CartContext } from 'constants/contexts';
import {
  Box, Typography, Stack, Divider,
} from '@mui/material';
import Price from 'components/Price';
import QuantityInput from 'components/QuantityInput';
import { priceTransformer } from 'utils';
import { getItemImage, getItemTotalPrices } from 'utils/item';
import { pluralize } from 'utils/string';
import { env } from 'constants';

function Items(props) {
  const { items, changeQuantity } = useContext(CartContext);

  function getSize(item) {
    if (item.selection?.size) {
      return item.sizes.find((s) => s.position === item.selection.size);
    }
  }

  if (items.length === 0) {
    return (
      <Stack justifyContent="center" alignItems="center" sx={{ flex: 1, height: '100%' }}>
        <Icon name="cart-outlined" size={40} sx={{ color: 'text.disabled' }} />
        <Typography variant="body-md" mt={2} color="text.secondary" textAlign="center">
          Your cart is empty
          <br />
          Add items to get started
        </Typography>
      </Stack>
    );
  }
  return (
    <Stack spacing={2} divider={<Divider />} {...props}>
      {items.map((item, index) => (
        <Box key={index}>
          <Stack
            direction="row"
            flexWrap="nowrap"
            justifyContent="space-between"
            spacing={2}
          >
            <Stack direction="column" gap={1.5}>
              {getItemImage(item) && (
                <div>
                  <img src={getItemImage(item)} width={64} height={64} style={{ borderRadius: 8, objectFit: 'cover' }} />
                </div>
              )}
              <Stack>
                <Typography
                  variant="title-md"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: '2',
                    WebkitBoxOrient: 'vertical',
                  }}
                >
                  {item.name}
                </Typography>
                <Typography variant="title-xs">{getSize(item)?.name}</Typography>
              </Stack>
            </Stack>

            <Price {...getItemTotalPrices(item)} />
          </Stack>
          <Stack mt={1}>
            <Stack color="text.secondary" flexWrap="wrap">
              {item?.selection?.modifiers?.map((m, i) => (
                <Typography variant="body-caption" key={i}>
                  +
                  {' '}
                  {m.title}
                  {' '}
                  (
                  {priceTransformer(m.price)}
                  )
                </Typography>
              ))}
            </Stack>
            {item.selection?.message && (
              <Typography variant="body-caption" mt={0.5} color="text.secondary">
                Special note:
                <br />
                {item.selection.message}
              </Typography>
            )}
          </Stack>
          <Stack mt={0.5} pt={1} gap={2} direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center">
              <QuantityInput
                value={item.selection.qty}
                onChange={(qty) => {
                  changeQuantity({
                    itemIndex: index,
                    qty,
                  });
                }}
                sx={{ ml: -1 }}
              />
              {env.IS_CATERING && <Typography variant="body-md">{pluralize(item?.catering_label || 'Person', item.selection.qty)}</Typography>}
            </Stack>
            {env.IS_CATERING && (
              <Typography variant="body-caption" color="text.secondary">
                Serves
                {' '}
                {((getSize(item)?.serving_size || 1) * item.selection.qty)}
                {' '}
                {pluralize('person', ((getSize(item)?.serving_size || 1) * item.selection.qty))}
              </Typography>
            )}
          </Stack>

        </Box>
      ))}
    </Stack>
  );
}

export default Items;
